import React, {useState} from 'react';
import { Outlet } from 'react-router-dom';
import { linkTo } from '../../utils/uiUtils';
import { LISTING_TYPE } from '../../platformUtils';

// hooks
import useMostPopularProperties from '../../hooks/useMostPopularProperties';
import useTrendingProperties from '../../hooks/useTrendingProperties';
import useRecommendedProperties from '../../hooks/useRecommendedProperties';

// components
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import SidebarNav from '../../components/SidebarNav/SidebarNav';
import SidebarNavItem from '../../components/SidebarNavItem/SidebarNavItem';
import SidebarNavDivider from '../../components/SidebarNavDivider/SidebarNavDivider';
import SidebarNavHeader from '../../components/SidebarNavHeader/SidebarNavHeader';

// media
import alertIconGreen from '../../media/simple-mono-icons/alert-icon-green.svg';
import alertIconGrey from '../../media/simple-mono-icons/alert-icon-grey.svg';
import questionCircleIconGreen from '../../media/simple-mono-icons/question-circle-icon-green.svg';
import questionCircleIconGrey from '../../media/simple-mono-icons/question-circle-icon-grey.svg';
import dollarCircleIconGreen from '../../media/simple-mono-icons/dollar-circle-icon-green.svg';
import dollarCircleIconGrey from '../../media/simple-mono-icons/dollar-circle-icon-grey.svg';
import houseIconGreen from '../../media/simple-mono-icons/house-icon-green.svg';
import houseIconGrey from '../../media/simple-mono-icons/house-icon-grey.svg';


function AccountPageLayout(props) {
    return <>
        <div className="relative">
            <div className="absolute left-0 top-0 right-0">
                <Navbar bg="transparent" hideLogo={true} />
            </div>
            <div className="flex bg-lighter-grey min-h-screen">
                <SidebarNav>
                    <SidebarNavItem link="/account/properties" activeIcon={houseIconGreen} inactiveIcon={houseIconGrey}>My Property</SidebarNavItem>
                    <SidebarNavItem link="/account/bids" activeIcon={dollarCircleIconGreen} inactiveIcon={dollarCircleIconGrey}>My Bids</SidebarNavItem>
                    <SidebarNavDivider />
                    <SidebarNavHeader>Settings</SidebarNavHeader>
                    <SidebarNavItem link="/account/notifications" activeIcon={alertIconGreen} inactiveIcon={alertIconGrey}>Notifications</SidebarNavItem>
                    <SidebarNavItem link="/account/help" activeIcon={questionCircleIconGreen} inactiveIcon={questionCircleIconGrey}>Help Center</SidebarNavItem>
                </SidebarNav>
                <div className="flex-grow relative">
                    <div className="px-8 pb-12">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>;
}
export default AccountPageLayout;